import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./Components/Navbar/Navbar";
import "./App.css";
import About from "./about/about";
import BE from "./Drinks/BE";
import BanhMi from "./BanhMi/BanhMi";
import CC from "./Pastries/CoconutCroissant";
import Coffee from "./Drinks/Coffee";
import VeganCoffee from "./Drinks/VeganCoffee";
import Contact from "./Contact/contact";
import Home from "./Home/Home";
import Menu from "./Menu/Menu";
import ThankYouPage from "./Contact/ThankYouPage";
import VeganAlmondCroissant from "./Pastries/VeganAlmondCroissant";
import VeganB from "./VietPastries/VeganB";
import VeganBPC from "./VietPastries/VeganBPC";
import VeganBanhMi from "./VeganBanhMi/VeganBanhMi";
import VeganC from "./Pastries/VeganC";
import VeganCC from "./VeganCC/VeganCC";
import VeganD from "./VietPastries/VeganD";
import VeganFC from "./VeganFC/VeganFC";
import VeganFriedChickenPieces from "./VeganFC/VeganFriedChickenPieces";
import VeganGrilledChicken from "./VeganGC/VeganGrilledChicken";
import VeganGrilledPork from "./VeganGF/VeganGrilledPork";
import VeganHNC from "./Pastries/VeganHNC";
import VeganLemongrassSteak from "./VeganGF/VeganLemongrassSteak";
import VeganMenu from "./VeganMenu/VeganMenu";
import VeganPP from "./VietPastries/VeganPP";
import VeganPateMeatLoaf from "./VeganPML/VeganPateMeatLoaf";
import VeganPorkMeatballs from "./VeganPM/VeganPorkMeatballs";
import VeganProtien from "./VeganProtien/VeganProtien";
import VeganSB from "./VietPastries/VeganSB";
import VeganSE from "./VietPastries/VeganSE";
import VeganSMB from "./VietPastries/VeganSMB";
import VeganShreddedPorkSkin from "./VegannSPS/VeganShreddedPorkSkin";
import VeganSpecialCombo from "./VeganSC/VeganSpecialCombo";
import VietnameseTea from "./VietnameseTea/VietnameseTea";
import ColdCutHam from "./BanhMi/ColdCutHam";
import ShreddedChicken from "./BanhMi/ShreddedChicken";
import PatePorkMeatLoaf from "./BanhMi/PatePorkMeatloaf";
import GrilledPork from "./BanhMi/GrilledPork";
import GrilledChicken from "./BanhMi/GrilledChicken";
import SpecialCombination from "./BanhMi/SpecialCombination";
import FriedEgg from "./BanhMi/FriedEgg";
import GrilledBeef from "./BanhMi/GrilledBeef";
import HamCheeseCroissantSandwich from "./BanhMi/HamCheeseCroissantSandwich";
import VeganHamCheeseCroissantSandwich from "./VeganBanhMi/VeganHamCheeseCroissantSandwich";
import VeganChickenCroissantSandwich from "./VeganBanhMi/VeganChickenCroissantSandwich";
import HNC from "./Pastries/HNC";
import Croissant from "./Pastries/Croissant";
import PuffPastry from "./VietPastries/PuffPastry";
import SoftMiniBuns from "./VietPastries/SoftMiniBuns";
import SteamedBun from "./VietPastries/SteamedBun";
import PandanMungBean from "./Drinks/PandanMungBean";
import SamBoLuong from "./Drinks/SamBoLuong";
import VeganSavoryEmpanada from "./VietPastries/VeganSavoryEmpanada";
import VeganGuavaTurnover from "./Pastries/VeganGuavaTurnover";
import VeganAppleTurnover from "./Pastries/VeganAppleTurnover";
import VeganPineappleTurnover from "./Pastries/VeganPineappleTurnover";
import HamAndCheeseHotBake from "./Pastries/HamAndCheeseHotBake";
import VeganHamAndCheeseHotBake from "./Pastries/VeganHamAndCheeseHotBake";
import ChickenHotBake from "./Pastries/ChickenHotBake";
import VeganChickenHotBake from "./Pastries/VeganChickenHotBake";
import VeganHamAndCheeseCroissantJalapeno from "./Pastries/VeganHamAndCheeseCroissantJalapeno";
import PandanHoneycombCake from "./VietPastries/PandanHoneycombCake";
import FriedOysterMushroom from "./VeganBanhMi/FriedOysterMushroom";
import PandanXoi from "./Xoi/PandanXoi";
// import RedXoi from "./Xoi/RedXoi";
// import CornXoi from "./Xoi/CornXoi";
import MagentaLeavesXoi from "./Xoi/MagentaLeavesXoi";
// import PeanutXoi from "./Xoi/PeanutXoi";
// import DurianXoi from "./Xoi/DurianXoi";
import VeganChickenXoi from "./Xoi/VeganChickenXoi";
import SweetXoi from "./Xoi/SweetXoi";
import Xoi from "./Xoi/Xoi";
import ChickenXoi from "./Xoi/ChickenXoi";
import PennywortJuice from "./Drinks/PennywortJuice";
import VeganSoftTaroBun from "./VietPastries/VeganSoftTaroBun";
import VeganSoftCoconutBun from "./VietPastries/VeganSoftCoconutBun";
import VeganSoftDurianBun from "./VietPastries/VeganSoftDurianBun";
import VeganSoftMungBeanBun from "./VietPastries/VeganSoftMungBeanBun";
import VeganChickenCroissant from "./Pastries/VeganChickenCroissant";
import Wholesale from "./Wholesale/Wholesale";
import PistachioCroissant from "./Pastries/PistachioCroissant";
import AlmondCroissant from "./Pastries/AlmondCroissant";
import VeganPistachioCroissant from "./Pastries/VeganPistachioCroissant";
import VeganPatechaud from "./VietPastries/VeganPatechaud";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import MetaPageViewTracker from "./Components/MetaPageViewTracker/MetaPageViewTracker";
import CanonicalTag from "./Components/CanonicalTag/CanonicalTag";
import { sendMetaEvent } from "./hooks/useMetaTracking";
import PrivacyPolicy from "./Legal/PrivacyPolicy";
import TermsOfService from "./Legal/TermsOfService";
import AccessibilityStatement from "./Legal/AccessibilityStatement";

const ORDER_URL = "https://order.toasttab.com/online/dong-hung-vien";

function App() {

  useEffect(() => {
    const handleToastOrderClick = (event) => {
      const anchor = event.target.closest("a[href]");

      if (!anchor) {
        return;
      }

      const href = anchor.getAttribute("href") || "";
      if (!href.startsWith(ORDER_URL)) {
        return;
      }

      sendMetaEvent(
        "InitiateCheckout",
        {
          content_name: "Toast Online Ordering",
          content_category: "Online Ordering",
          content_ids: ["toast_online_ordering"],
          content_type: "product_group",
          currency: "USD",
          destination: href,
        },
        { keepalive: true }
      );
    };

    document.addEventListener("click", handleToastOrderClick, true);

    return () => {
      document.removeEventListener("click", handleToastOrderClick, true);
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <ScrollToTop />
        <MetaPageViewTracker />
        <CanonicalTag />
        <Navbar />
        <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/vegan-protein-to-go" element={<VeganProtien />} />
          <Route path="/vietnamese-tea-ceremony" element={<VietnameseTea />} />
          <Route path="/mooncakes/*" element={<Navigate to="/" replace />} />
          <Route path="/mooncake" element={<Navigate to="/" replace />} />
          <Route path="/regular-menu" element={<Menu />} />
          <Route path="/vegan-menu" element={<VeganMenu />} />
          <Route path="/vegan-fried-chicken" element={<VeganFC />} />
          <Route path="/vegan-fried-chicken-pieces" element={<VeganFriedChickenPieces />} />
          <Route path="/vegan-coconut-croissant" element={<VeganCC />} />
          <Route path="/vegan-banh-mi" element={<VeganBanhMi />} />
          <Route path="/banh-mi" element={<BanhMi />} />
          <Route path="/about" element={<About />} />

          {/* Newly added routes */}
          <Route path="/vegan-special-combo" element={<VeganSpecialCombo />} />
          <Route path="/vegan-grilled-pork" element={<VeganGrilledPork />} />
          <Route path="/vegan-grilled-chicken" element={<VeganGrilledChicken />} />
          <Route path="/vegan-lemongrass-steak" element={<VeganLemongrassSteak />} />
          <Route path="/vegan-pate-meatloaf" element={<VeganPateMeatLoaf />} />
          <Route path="/vegan-pork-meatballs" element={<VeganPorkMeatballs />} />
          <Route path="/vegan-shredded-pork-skin" element={<VeganShreddedPorkSkin />} />
          <Route path="/fried-oyster-mushroom" element={<FriedOysterMushroom />} />
          <Route path="/ham-and-cheese-croissant-sandwich" element={<HamCheeseCroissantSandwich />} />
          <Route path="/vegan-ham-and-cheese-croissant-sandwich" element={<VeganHamCheeseCroissantSandwich />} />
          <Route path="/vegan-chicken-croissant-sandwich" element={<VeganChickenCroissantSandwich />} />
          <Route path="/xoi-pandan" element={<PandanXoi />} />
          {/* <Route path="/xoi-red" element={<RedXoi />} /> */}
          {/* <Route path="/xoi-corn" element={<CornXoi />} /> */}
          <Route path="/xoi-magenta-leaves" element={<MagentaLeavesXoi />} />
          {/* <Route path="/xoi-peanut" element={<PeanutXoi />} /> */}
          {/* <Route path="/xoi-durian" element={<DurianXoi />} /> */}
          <Route path="/xoi-vegan-chicken" element={<VeganChickenXoi />} />
          <Route path="/sweet-xoi" element={<SweetXoi />} />
          <Route path="/xoi" element={<Xoi />} />
          <Route path="/xoi-chicken" element={<ChickenXoi />} />
          <Route path="/wholesale" element={<Wholesale />} />

          <Route path="/coconut-croissant" element={<CC />} />

          <Route path="/vegan-croissant" element={<VeganC />} />
          <Route path="/vegan-ham-and-cheese-croissant" element={<VeganHNC />} />
          <Route path="/vegan-almond-croissant" element={<VeganAlmondCroissant />} />

          <Route path="/vietnamese-baguette" element={<VeganB />} />
          <Route path="/vegan-beef-puff-pastry" element={<VeganBPC />} />
          <Route path="/vegan-pate-chaud" element={<VeganPatechaud />} />
          <Route path="/vegan-vietnamese-donut" element={<VeganD />} />
          <Route path="/vegan-puff-pastry" element={<VeganPP />} />
          <Route path="/vegan-steamed-bun" element={<VeganSB />} />
          <Route path="/vegan-sweet-empanada" element={<VeganSE />} />
          <Route path="/vegan-soft-mini-buns" element={<VeganSMB />} />
          <Route path="/vegan-soft-taro-bun" element={<VeganSoftTaroBun />} />
          <Route path="/vegan-soft-coconut-bun" element={<VeganSoftCoconutBun />} />
          <Route path="/vegan-soft-mung-bean-bun" element={<VeganSoftMungBeanBun />} />
          <Route path="/vegan-soft-durian-bun" element={<VeganSoftDurianBun />} />

          <Route path="/vegan-vietnamese-coffee" element={<VeganCoffee />} />
          <Route path="/rau-ma" element={<PennywortJuice />} />
          <Route path="/vietnamese-beauty-elixir" element={<BE />} />
          <Route path="/vietnamese-coffee" element={<Coffee />} />
          <Route path="/cold-cut-ham" element={<ColdCutHam />} />
          <Route path="/shredded-chicken" element={<ShreddedChicken />} />
          <Route path="/pate-pork-meatloaf" element={<PatePorkMeatLoaf />} />
          <Route path="/grilled-pork" element={<GrilledPork />} />
          <Route path="/grilled-chicken" element={<GrilledChicken />} />
          <Route path="/special-combination" element={<SpecialCombination />} />
          <Route path="/fried-egg" element={<FriedEgg  />} />
          <Route path="/grilled-beef" element={<GrilledBeef  />} />
          <Route path="/puff-pastry" element={<PuffPastry />} />
          <Route path="/vegan-chicken-croissant" element={<VeganChickenCroissant />} />
          <Route path="/pistachio-croissant" element={<PistachioCroissant />} />
          <Route path="/vegan-pistachio-croissant" element={<VeganPistachioCroissant />} />
          <Route path="/almond-croissant" element={<AlmondCroissant />} />

          <Route path="/ham-and-cheese-croissant" element={<HNC />} />
          <Route path="/croissant" element={<Croissant />} />
          <Route path="/soft-mini-buns" element={<SoftMiniBuns />} />
          <Route path="/steamed-bun" element={<SteamedBun />} />
          <Route path="/sam-bo-luong" element={<SamBoLuong />} />
          <Route path="/pandan-mung-bean" element={<PandanMungBean />} />
          <Route path="/vegan-savory-empanada" element={<VeganSavoryEmpanada />} />
          <Route path="/vegan-guava-turnover" element={<VeganGuavaTurnover />} />
          <Route path="/vegan-apple-turnover" element={<VeganAppleTurnover />} />
          <Route path="/vegan-pineapple-turnover" element={<VeganPineappleTurnover />} />
          <Route path="/ham-and-cheese-hot-bake" element={<HamAndCheeseHotBake />} />
          <Route path="/vegan-ham-and-cheese-hot-bake" element={<VeganHamAndCheeseHotBake />} />
          <Route path="/chicken-hot-bake" element={<ChickenHotBake />} />
          <Route path="/vegan-chicken-hot-bake" element={<VeganChickenHotBake />} />
          <Route path="/vegan-ham-and-cheese-jalapeno-croissant" element={<VeganHamAndCheeseCroissantJalapeno />} />
          <Route path="/pandan-honeycomb-cake" element={<PandanHoneycombCake />} />

          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfService />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          {/* ← catch-all: any unmatched URL */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </main>
      </Router>
    </HelmetProvider>
  );
}
 
export default App;
